import React, {
  cloneElement,
  useState,
  useEffect, useMemo,useCallback
} from 'react'
import moment from 'moment'
import { toast } from 'react-toastify'

import api from '../../api'
import { clearCountingTrackingByBins } from '../../api'
import { sortText } from '../../utils/sortHelper'

import ButtonSecondary from '../ui/ButtonSecondary'
import BaseCheckbox from '../BaseCheckbox'
import BaseSearchBar from '../BaseSearchBar'
import BaseTable from '../BaseTable'
import InventoryPartModal from './InventoryPartModal'

import './index.css'
import DashedLink from "../DashedLink";
import BaseModal from "../BaseModal";
import ButtonPrimary from "../ui/ButtonPrimary";

const BinSelectCell = ({ row, actions }) => (
  <BaseCheckbox
    checkboxId={`clear-counts-bin-${row.bin}`}
    isChecked={!!actions?.checked?.[row.bin]}
    onCheck={() => actions?.toggle?.(row.bin)}
  />
)


const InventoryBlock = (props) => {
  const [ isPartModalOpen, setIsPartModalOpen ] = useState(null)
  const [ modalError, setModalError ] = useState('')

  const [ localInventory, setLocalInventory ] = useState(null)
  const [ sortedLocalInventory, setSortedLocalInventory ] = useState(null)
  const [ inventorySort, setInventorySort ] = useState({ isDesc: false, prop: '' })

  const [ searchBarInput, setSearchBarInput ] = useState('')
  const [ searchBarInputModal, setSearchBarInputModal ] = useState('');
  const [ summary, setSummary ] = useState({
    bins: 0,
    parts: 0,
    quantity: 0,
  })

  const [localSummaryBins, setLocalSummaryBins] = useState(null);
  const [localSummaryBinsCopy, setLocalSummaryBinsCopy] = useState(null);
  const [sortedLocalSummaryBins, setSortedLocalSummaryBins] = useState(null);
  const [ tableDataSort, setTableDataSort ] = useState({ isDesc: false, prop: '' });

  const [isViewDetailsModalOpened, setIsViewDetailsModalOpened] = useState(false);
  const [activeIndexTab, setActiveIndexTab] = useState(0);
  const [checkedBins, setCheckedBins] = useState({});
  const [isClearingCounts, setIsClearingCounts] = useState(false);

  const toggleBinSelect = useCallback((binName) => {
    setCheckedBins(prev => {
      const next = { ...prev }
      if (next[binName]) {
        delete next[binName]
      } else {
        next[binName] = true
      }
      return next
    })
  }, [])

  const selectedBinNames = Object.keys(checkedBins)

  const handleClearCounts = async () => {
    if (selectedBinNames.length === 0) return
    const confirmed = window.confirm(
      `Clear scan counts for ${selectedBinNames.length} bin(s)? This cannot be undone.`
    )
    if (!confirmed) return

    try {
      setIsClearingCounts(true)
      const res = await clearCountingTrackingByBins(props.job.UUID, selectedBinNames)
      if (res?.data?.status === 'failed') {
        toast.warn(`Clear counts failed: ${res.data.message || 'unknown error'}`, {
          position: toast.POSITION.TOP_CENTER,
        })
        return
      }
      const refreshed = await api.getBinSummaryForCountingJob(props.job.UUID)
      setLocalSummaryBins(refreshed.data.data)
      setLocalSummaryBinsCopy(refreshed.data.data)
      setCheckedBins({})
      toast.warn(`Cleared counts for ${selectedBinNames.length} bin(s).`, {
        position: toast.POSITION.TOP_CENTER,
      })
    } catch (e) {
      console.error('clearCountingTrackingByBins error', e)
      toast.warn('Clear counts failed. See console.', {
        position: toast.POSITION.TOP_CENTER,
      })
    } finally {
      setIsClearingCounts(false)
    }
  }


  useEffect(() => {
      api.getBinSummaryForCountingJob(props.job.UUID)
          .then(res => {
            setLocalSummaryBins(res.data.data);
            setLocalSummaryBinsCopy(res.data.data);
          }).catch(error =>  console.log('summaryBins error', error))
  }, [props.job.UUID, isPartModalOpen ]);


  console.log('localSummaryBins',localSummaryBins)

  useEffect(() => {
    !localInventory &&
    api.getCountingResultsForAGivenJob(props.job.UUID).then(res => setLocalInventory(res.data.data))
  }, [])

  useEffect(() => {
    api.getCountingSummaryForAGivenJob(props.job.UUID).then(res => {
      const data = res.data.data
      setSummary({
        bins: data ? data.binCount : 0,
        parts: data ? data.partNumberCount : 0,
        quantity: data ? data.itemCount : 0,
      })
    })
  }, [ localInventory ])

  useEffect(() => {
    if (!localInventory) return
    let listToSort = props.searchTerm.type === 'user' && props.searchTerm.value === 'whole team'
      ? localInventory
      : props.searchedInventory

    const { isDesc, prop } = inventorySort
    let sorted
    if (prop === 'scheduledStartTime') {
      sorted = [ ...listToSort ].sort((a, b) => {
        const diff = moment(a[prop], 'YYYY-MM-DD HH:mm:ss') - moment(b[prop], 'YYYY-MM-DD HH:mm:ss')
        return isDesc ? diff : diff * -1
      })
    } else {
      sorted = [ ...listToSort ].sort(sortText(prop, isDesc))
    }
    setSortedLocalInventory(sorted)
  }, [ inventorySort, props.searchedInventory, localInventory ])

  useEffect(() => {
    if (!localSummaryBins) return;
    let listToSort = localSummaryBins;

    const { isDesc, prop } = tableDataSort;
    let sorted;

    sorted = [ ...listToSort ].sort(sortText(prop, isDesc));

    setSortedLocalSummaryBins(sorted);
  }, [ localSummaryBins, tableDataSort, isPartModalOpen ]);

  useEffect(() => {
    if (props.searchTerm.type === 'user') {
      setSearchBarInput('')
    }
  }, [ props.searchTerm ])

  const sortTable = ({ dataKey }) => {
    setInventorySort({
      isDesc: inventorySort.prop === dataKey ? !inventorySort.isDesc : false,
      prop: dataKey,
    })
  }

  const sortTableModal = ({ dataKey }) => {
    setTableDataSort({
      isDesc: tableDataSort.prop === dataKey ? !tableDataSort.isDesc : false,
      prop: dataKey,
    })
  }

  const editPart = (part) => {
    togglePartModal(part)
  }

  const actions = {
    edit: editPart,
  }

  const togglePartModal = (part) => {
    if (part) {
      setIsPartModalOpen({ part })
    } else {
      setIsPartModalOpen(!isPartModalOpen)
    }
  }

  const deletePart = (partToDelete) => {
    api.deleteCountingResult({ bin: partToDelete.bin, partNumber: partToDelete.partNumber }, props.job.UUID)
    const newLocalInventory = localInventory.filter(part => {
      return partToDelete.id !== part.id
    })
    setLocalInventory(newLocalInventory)
    setIsPartModalOpen(null)
  }

  const savePart = async (part) => {
    try {
      const res = await api.updateCountingResult(part, props.job.UUID)
      if (res.data.status === 'failed') {
        setModalError(res.data.message)
        return
      }
      const newLocalInventory = localInventory.map(localPart => {
        return localPart.id === part.id ? part : localPart
      })
      setLocalInventory(newLocalInventory)
      setIsPartModalOpen(null);
    } catch (e) {
      console.error(e)
    }
  }

  const addPart = async (part) => {
    try {
      const res = await api.addCountingResult({...part, bin: part.bin.toUpperCase()}, props.job.UUID)
      if (res.data.status === 'failed') {
        setModalError(res.data.message)
        return
      }
      setLocalInventory([ ...localInventory, { ...part, id: res.data.data.id, bin: part.bin.toUpperCase() } ])
      setIsPartModalOpen(null);
    } catch (e) {
      console.error(e)
    }
  }

  const handleSlash = useCallback((str) => str.split('-').join(''), [])

  const onSearch = async (type, value) => {
    if (isViewDetailsModalOpened){

      setLocalSummaryBins(localSummaryBinsCopy.filter(item => {
        return  handleSlash(item.bin.toUpperCase()).includes(handleSlash(searchBarInputModal.toUpperCase()))
      }))
    }else {
      props.setSearchTerm({ type: 'text', value: searchBarInput })
    }
  }

  const onClear = () => {
    if (isViewDetailsModalOpened){
      setSearchBarInputModal('');
      api.getBinSummaryForCountingJob(props.job.UUID)
          .then(res => setLocalSummaryBins(res.data.data)).catch(error =>  console.log('summaryBins error', error))
    }else {
      props.setSearchTerm({ type: 'user', value: 'whole team' })
      setSearchBarInput('')
    }
  }

  const onSearchInputChange = (e) => {
    if (isViewDetailsModalOpened){
      setSearchBarInputModal(e.target.value)
    }else {
      if (e.target.value === '') {
        props.setSearchTerm({ type: 'user', value: 'whole team' })
      } else {
        setSearchBarInput(e.target.value)
      }
    }
  }

  const tableOptions = {
    columns: [
      {
        name: 'Bin',
        type: 'text',
        isSortable: true,
        dataKey: 'bin',
      },
      {
        name: 'Part Number',
        type: 'text',
        isSortable: true,
        dataKey: 'partNumber',
      },
      {
        name: 'Quantity',
        type: 'text',
        isSortable: true,
        dataKey: 'count',
      },
      {
        name: 'Edit',
        type: 'edit',
        dataKey: 'edit',
        isSortable: false,
      },
    ],
  }

  const isReadOnly = props.status === 'completed' || props.status === 'canceled' || props.status === 'aborted'
  tableOptions.columns = isReadOnly ? tableOptions.columns.filter(col => col.name !== 'Edit') : tableOptions.columns

  const sections = useMemo(() => [
      { title: 'All Bins', value: localSummaryBins && localSummaryBins.length},
    {title: 'Counted Bins', value: localSummaryBins && localSummaryBins.filter(bin => bin.partNumberCount > 0).length},
      {title: 'Uncounted Bins', value: localSummaryBins && localSummaryBins.filter(bin => bin.partNumberCount === 0).length}],
      [localSummaryBins, summary.bins, isPartModalOpen]);


  const canClearCounts = props.status === 'scan_started'

  const tableOptionsModal = {
    columns: [
      ...(canClearCounts ? [{
        name: '',
        type: 'component',
        component: cloneElement(<BinSelectCell />),
        dataKey: 'binSelect',
      }] : []),
      {
        name: 'Bin',
        type: 'text',
        isSortable: true,
        dataKey: 'bin',
        isReadOnly: true,
      },
      {
        name: 'Parts',
        type: 'text',
        isSortable: true,
        dataKey: 'partNumberCount',
        isReadOnly: true,
      },
      {
        name: 'Q-Ty',
        type: 'text',
        isSortable: true,
        dataKey: 'itemCount',
        isReadOnly: true,
      },
    ],
  }

  const modalTableActions = canClearCounts
    ? { binSelect: { checked: checkedBins, toggle: toggleBinSelect } }
    : undefined

  console.log('STATUS', props.status)

  const dataForModalTable = useMemo(() => {
    switch (activeIndexTab){
      case 0: return sortedLocalSummaryBins;
      case 1: return sortedLocalSummaryBins.filter(bin => bin.partNumberCount !== 0);
      case 2: return sortedLocalSummaryBins.filter(bin => bin.partNumberCount === 0);
    }
  }, [activeIndexTab, sortedLocalSummaryBins])

  const body = (
      <div className="inventory__detailed-view-modal">
        <h2 className={"inventory__detailed-view-modal-title"}>Bins Detailed View</h2>
        <div className={"inventory__detailed-view-modal-search-view "}>
          <BaseSearchBar
              placeholder="Search Bin"
              className="inventory__search inventory__search-extra-space"
              value={searchBarInputModal}
              onChange={onSearchInputChange}
              onClear={onClear}
              onSearch={onSearch}
          />
          <ButtonSecondary
              name="Search"
              onClick={onSearch}
          />
        </div>

        <div className={"inventory__detailed-view-modal-tabs"}>
          {
            sections.map((section, index) => (
                <p className={`inventory__detailed-view-modal-tabItem ${activeIndexTab === index && 'inventory__detailed-view-modal-tabItem-selected'}`}
                     onClick={() => setActiveIndexTab(index)}
                >
                  {section.title}({section.value})
                </p>
            ))
          }
        </div>
        <div className={"tab-view-root"}>
          <div className={`tab-view tab-width tab-width_${activeIndexTab}`} />
        </div>

        <BaseTable
            keyProp={'bin'}
            className="inventory__table"
            options={tableOptionsModal}
            data={dataForModalTable}
            actions={modalTableActions}
            onSort={sortTableModal} />
      </div>
  )

  const footer = (
      <div className={"inventory__detailed-view-modal-footer"}>
        {canClearCounts && (
          <ButtonSecondary
            name={`Clear Counts${selectedBinNames.length ? ` (${selectedBinNames.length})` : ''}`}
            onClick={handleClearCounts}
            disabled={selectedBinNames.length === 0 || isClearingCounts}
          />
        )}
        <ButtonPrimary  name="Close" onClick={()=>setIsViewDetailsModalOpened(false)} />
      </div>
  )

  return (
    <div className="inventory">
      <h3 className="inventory__title">Inventory Progress</h3>
      <div className="inventory__stats">
        <ul className="inventory__stats-list">
          <li className="inventory__stats-item">
            <span className="inventory__item-label">Bins</span>
            <span className="inventory__item-value">{summary.bins}/{localSummaryBinsCopy && localSummaryBinsCopy.length}</span>
            {
              props.status !=='scan_completed' && <DashedLink
                  className="inventory__detailed-view"
                  name={'Detailed View '}
                  onClick={() => setIsViewDetailsModalOpened(true)}
              />
            }
          </li>
        </ul>
        <ul className="inventory__stats-list">
          <li className="inventory__stats-item">
            <span className="inventory__item-label">Parts</span>
            <span className="inventory__item-value inventory__item-value-extra-margin">{summary.parts}</span>
          </li>
          <li className="inventory__stats-item">
            <span className="inventory__item-label">Quantity</span>
            <span className="inventory__item-value">{summary.quantity}</span>
          </li>
        </ul>
      </div>
      {props.orders.length >= 1 ? null :
        <>
          <div className="inventory__header">
            <BaseSearchBar
              placeholder="Search Bin or Part Number"
              className="inventory__search"
              value={searchBarInput}
              onChange={onSearchInputChange}
              onClear={onClear}
              onSearch={onSearch}
            />
            <ButtonSecondary
              name="Search"
              onClick={onSearch}
            />
            {!isReadOnly && <ButtonSecondary name="Add Part" onClick={() => togglePartModal(null)} />}
          </div>
          <BaseTable
            className="inventory__table"
            keyProp='id'
            onSort={sortTable}
            options={tableOptions}
            actions={actions}
            data={sortedLocalInventory}
          />

          {isPartModalOpen &&
           <InventoryPartModal
             onClose={() => togglePartModal(null)}
             part={isPartModalOpen.part}
             onDelete={deletePart}
             onSave={savePart}
             onAdd={addPart}
             modalError={modalError}
             removeError={() => setModalError('')}
           />}

          {
            isViewDetailsModalOpened && (
                <BaseModal
                    onClose={() => setIsViewDetailsModalOpened(false)}
                    body={body}
                    footer={footer}
                />
            )
          }
        </>

      }

    </div>
  )
}

export default InventoryBlock
